import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { ArrowLeft, Shield } from 'lucide-react';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [token, setToken] = useState('');

  const handleSetToken = () => {
    if (!token.trim()) {
      toast.error('Please enter an admin token');
      return;
    }

    // Set the token in localStorage
    localStorage.setItem('session_token', token.trim());
    toast.success('Admin token set successfully!');
    
    // Redirect to admin dashboard
    setTimeout(() => {
      window.location.href = '/admin';
    }, 500);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-blue-600 to-purple-800 px-4 py-8">
      <div className="max-w-2xl mx-auto">
        {/* Back Button */}
        <Button
          onClick={() => navigate('/')}
          variant="ghost"
          className="mb-6 text-white hover:bg-white/20"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back to Home
        </Button>

        <Card className="bg-white/95 backdrop-blur-lg p-8 rounded-3xl">
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <Shield className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Admin Access</h1>
            <p className="text-gray-600">Enter your admin session token to access the dashboard</p>
          </div>

          <div className="space-y-4">
            <div>
              <Label htmlFor="token" className="text-lg font-semibold text-gray-700 mb-2 block">
                Admin Token
              </Label>
              <Input
                id="token"
                type="text"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="Paste your admin token here..."
                className="h-14 text-base"
              />
            </div>

            <Button
              onClick={handleSetToken}
              className="w-full h-14 text-lg font-bold bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white rounded-xl"
            >
              Set Token & Access Dashboard
            </Button>
          </div>

          <div className="mt-8 p-4 bg-blue-50 rounded-xl">
            <h3 className="font-bold text-gray-800 mb-2">How to get your admin token:</h3>
            <ol className="text-sm text-gray-700 space-y-2 list-decimal list-inside">
              <li>Contact the development team</li>
              <li>Copy your unique admin session token</li>
              <li>Paste it in the field above</li>
              <li>Click "Set Token & Access Dashboard"</li>
            </ol>
          </div>

          <div className="mt-6 p-4 bg-yellow-50 border-2 border-yellow-300 rounded-xl">
            <p className="text-sm text-gray-700">
              <strong>⚠️ Security Note:</strong> Never share your admin token with anyone. 
              This token gives full access to manage users and tournament data.
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}
